export default function createSlug(text: string) {
  return text
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w-]+/g, "") // Remove all non-word chars except -
    .replace(/--+/g, "-") // Replace multiple - with single -
    .replace(/^-+|-+$/, ""); // Trim - from start of text and end of text
}
